import { castArray } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';

import { PaymentError } from 'hb-react/frontoffice/components/payments/PaymentTouchnet/components/PaymentError';
import { useAsyncPayment } from 'hb-react/shared/components/Payment/components/Stripe/hooks/use-async-payment';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import * as errorReporting from 'hb-react/shared/utils/errorReporting';

import TouchnetError from './errors/TouchnetError';

const PaymentTouchnet = ({
  getSecureLinkTicketUrl,
  ticketRequestObject,
  onSuccess,
  cartStatus,
}) => {
  const [secureLinkTicketData, setSecureLinkTicketData] = useState(null);
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useAsyncPayment({
    onSuccess,
    onError: () => {
      setError(true);
    },
  });

  useEffect(() => {
    if (cartStatus === 'draft') {
      axios
        .post(getSecureLinkTicketUrl, ticketRequestObject)
        .then((response) => {
          setSecureLinkTicketData(response.data);
        })
        .catch((error) => {
          errorReporting.captureException(
            new TouchnetError("Can't get client token from HB", error),
          );
          setErrorMessage(castArray(error.response.data.errors).join(' - '));
        });
    }
  }, []);

  if (secureLinkTicketData) {
    return (
      <Box>
        <AutoSubmitForm
          actionUrl={secureLinkTicketData.upay_url}
          params={{
            UPAY_SITE_ID: secureLinkTicketData.upay_site_id,
            TICKET: secureLinkTicketData.ticket,
            TICKET_NAME: ticketRequestObject.message.ticket_name,
          }}
        />
      </Box>
    );
  }

  return (
    <Box>
      {error || errorMessage ? (
        <PaymentError errorMessage={errorMessage} />
      ) : (
        <Loader size={24} />
      )}
    </Box>
  );
};

const AutoSubmitForm = ({ actionUrl, params }) => {
  const formRef = useRef(null);

  useEffect(() => {
    formRef.current.submit();
  }, []);

  return (
    <form ref={formRef} method="POST" action={actionUrl}>
      {Object.keys(params).map((name) => (
        <input type="hidden" name={name} value={params[name]} />
      ))}
    </form>
  );
};

PaymentTouchnet.propTypes = {
  getSecureLinkTicketUrl: PropTypes.string.isRequired,
  ticketRequestObject: PropTypes.object.isRequired,
  cartStatus: PropTypes.string,
  onSuccess: PropTypes.func,
};

export default PaymentTouchnet;
